import React from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";

const azul = "#0877cf";
const fundo = "#f4f7fb";

function BarraSistema({ cliente = false }) {
  return (
    <Box sx={{ height: 38, bgcolor: azul, color: "white", display: "flex", alignItems: "center", px: 1.5, gap: 2, fontSize: 11 }}>
      <Box sx={{ fontWeight: 800 }}>LOGO</Box>
      <span>Página Principal</span><span>O.S. interna</span><span>Cadastrar⌄</span>
      {!cliente && <><span>SGQ</span><span>Etiquetas</span><span>Rupturas do Dia</span></>}
      <Box sx={{ ml: "auto", px: 1.2, py: 0.4, bgcolor: "rgba(255,255,255,.12)", borderRadius: 3 }}>{cliente ? "Cliente" : "Usuário"} ◯</Box>
    </Box>
  );
}

function Campo({ texto, largura = "100%" }) {
  return <Box sx={{ width: largura, height: 34, border: "1px solid #bcc5d0", borderRadius: 1.2, px: 1.2, display: "flex", alignItems: "center", color: "#637083", bgcolor: "white", fontSize: 11 }}>{texto}</Box>;
}

function Botao({ children, verde = false }) {
  return <Button size="small" variant="contained" sx={{ minHeight: 29, fontSize: 10, textTransform: "none", bgcolor: verde ? "#2e7d32" : "#0061ad", whiteSpace: "nowrap" }}>{children}</Button>;
}

function Tabela({ cabecalhos, linhas }) {
  return (
    <Box sx={{ border: "1px solid #dbe1e8", borderRadius: 1, overflow: "hidden", bgcolor: "white" }}>
      <Box sx={{ display: "grid", gridTemplateColumns: `repeat(${cabecalhos.length}, minmax(70px, 1fr))`, bgcolor: "#f5f7fa", borderBottom: "1px solid #dbe1e8" }}>
        {cabecalhos.map((item) => <Box key={item} sx={{ p: 0.8, color: "#0645a5", fontWeight: 700, fontSize: 9 }}>{item}</Box>)}
      </Box>
      {linhas.map((linha, indice) => (
        <Box key={indice} sx={{ display: "grid", gridTemplateColumns: `repeat(${cabecalhos.length}, minmax(70px, 1fr))`, borderBottom: indice < linhas.length - 1 ? "1px solid #e6e9ee" : 0 }}>
          {linha.map((item, coluna) => <Box key={coluna} sx={{ p: 0.8, fontSize: 9, color: "#344054" }}>{item}</Box>)}
        </Box>
      ))}
    </Box>
  );
}

function Dashboard({ etapa }) {
  return (
    <Box sx={{ bgcolor: fundo, minHeight: 270 }}><BarraSistema />
      <Box sx={{ display: "flex" }}>
        <Box sx={{ width: 105, bgcolor: azul, color: "white", minHeight: 232, p: 1, fontSize: 10 }}>
          <Box sx={{ textAlign: "center", py: 2, fontWeight: 800 }}>LOGO</Box>
          {['Admin⌄','Cadastrar⌄','O.S. interna','Dosagem','Relatórios'].map(x => <Box key={x} sx={{ py: 1 }}>{x}</Box>)}
        </Box>
        <Box sx={{ flex: 1, p: 1.5 }}>
          {etapa <= 1 && <Paper sx={{ p: 1.2 }}><Typography sx={{ color: azul, fontSize: 10, fontWeight: 700 }}>Acesso rápido</Typography><Stack direction="row" spacing={1} mt={1}>{['Agenda','Materiais','Equipamentos','Obras','Laudos'].map(x => <Box key={x} sx={{ width: 73, height: 58, bgcolor: fundo, borderRadius: 1.5, display: "grid", placeItems: "center", fontSize: 9, textAlign: "center" }}>▣<br />{x}</Box>)}</Stack></Paper>}
          {etapa >= 2 && <Stack direction="row" spacing={1.5}>{['Resistência do Concreto','Ensaios da Semana','NCs por Tipo'].map((x,i) => <Paper key={x} sx={{ flex: 1, p: 1, height: 125 }}><Typography fontSize={11}>{x}</Typography><Box sx={{ mt: 2, height: 70, background: i===0?'linear-gradient(155deg,transparent 48%,#1976d2 49%,#1976d2 52%,transparent 53%)':'repeating-linear-gradient(90deg,#1976d2 0 18px,transparent 18px 30px)', opacity:.8 }} /></Paper>)}</Stack>}
        </Box>
      </Box>
    </Box>
  );
}

function Materiais({ etapa }) {
  const lista = etapa === 0;
  const origem = etapa === 1;
  const classificacao = etapa === 2;
  const edicao = etapa === 3;
  const historico = etapa === 4;
  return <Box sx={{ bgcolor: fundo, minHeight: 270 }}><BarraSistema /><Box sx={{ p: 1.5 }}><Typography fontWeight={700} fontSize={15}>Lista de Materiais</Typography>
    {lista&&<><Stack direction="row" spacing={1} my={1}><Botao>+ Cadastrar</Botao><Campo texto="Pesquisar" /><Campo texto="Status: Todos⌄" largura={130} /></Stack><Tabela cabecalhos={['Código','Data','Cliente','Obra','Fornecedor','Local Coleta','Descrição','Editar','Status','Histórico']} linhas={[[267,'03/07/2026','Tabocas','LT 500 kV','Márcio Alves','Teixeira de Freitas / BA','Areia natural escura','✎','Não⌄','↶'],[266,'19/06/2026','Tabocas','Todas as obras','Laboratório','Laboratório','Rede pública potável','✎','Não⌄','↶'],[265,'15/06/2026','ER Mineração','Britador','Depósito','Depósito','Brita 1','✎','Não⌄','↶']]} /></>}
    {origem&&<Paper sx={{ mt: 1, p: 1.5 }}><Typography fontWeight={700} mb={1}>Cadastrar Material — origem e coleta</Typography><Stack spacing={1}><Campo texto="Código: Automático"/><Campo texto="Cliente *"/><Campo texto="Obra *"/><Stack direction="row" spacing={1}><Campo texto="Fornecedor *"/><Campo texto="Local da Coleta / Jazida"/></Stack><Typography fontSize={10}>☐ Material entregue pelo cliente</Typography><Campo texto="Colaborador que realizou a coleta *"/><Stack direction="row" justifyContent="flex-end" spacing={1}><Button size="small">Cancelar</Button><Botao>Salvar</Botao></Stack></Stack></Paper>}
    {classificacao&&<Paper sx={{ mt: 1, p: 1.5 }}><Typography fontWeight={700} mb={1}>Cadastrar Material — classificação</Typography><Stack spacing={1}><Typography fontSize={10}>☐ Cimento &nbsp; ☐ Aditivo &nbsp; ☐ Adição &nbsp; ☐ Água &nbsp; ☐ Agregado graúdo &nbsp; ☒ Agregado miúdo &nbsp; ☐ Solos</Typography><Stack direction="row" spacing={1}><Campo texto="Data *"/><Campo texto="Descrição *: Areia natural escura"/></Stack><Campo texto="Ensaios previstos"/><Typography fontSize={9} color="text.secondary">Para cimento, aditivo, adição ou água, informe também a massa específica (kg/dm³).</Typography><Stack direction="row" justifyContent="flex-end" spacing={1}><Button size="small">Cancelar</Button><Botao>Salvar</Botao></Stack></Stack></Paper>}
    {edicao&&<Paper sx={{ mt: 1, p: 1.5 }}><Typography fontWeight={700} mb={1}>Editar Material</Typography><Stack spacing={1}><Campo texto="Código: Automático"/><Campo texto="Cliente: Tabocas Participações Empreendimentos S.A"/><Campo texto="Obra: 138 - LT 500 kV Poções III - Trecho Sul"/><Stack direction="row" spacing={1}><Campo texto="Fornecedor: Márcio Alves Mineração"/><Campo texto="Local: Teixeira de Freitas / BA"/></Stack><Typography fontSize={10}>☒ Material entregue pelo cliente</Typography><Typography fontSize={10}>☐ Cimento &nbsp; ☐ Aditivo &nbsp; ☐ Adição &nbsp; ☐ Água &nbsp; ☐ Agregado graúdo &nbsp; ☒ Agregado miúdo &nbsp; ☐ Solos</Typography><Stack direction="row" spacing={1}><Campo texto="Data: 03/07/2026"/><Campo texto="Status na lista: Em andamento⌄"/></Stack><Stack direction="row" justifyContent="flex-end" spacing={1}><Button size="small">Cancelar</Button><Botao>Salvar</Botao></Stack></Stack></Paper>}
    {historico&&<Paper sx={{ mt: 2, p: 1.5, maxWidth: 720, mx: 'auto' }}><Typography fontWeight={700} mb={1.5}>Histórico do Material — Código 267</Typography><Tabela cabecalhos={['Data','Evento','Usuário']} linhas={[['06/07/2026, 14:15:51','Dados do material alterados','Silvio Paiva'],['03/07/2026, 09:22:47','Cadastro do material criado','Sistema']]} /><Stack direction="row" justifyContent="flex-end" mt={1.5}><Button size="small" variant="outlined">Voltar</Button></Stack></Paper>}
  </Box></Box>;
}

function CadastroSimples({ tipo, etapa }) {
  const cliente = tipo === "clientes";
  const titulo = cliente ? "Cadastro de Clientes" : "Cadastro de Obras";
  const novo = etapa === 1;
  const headers = cliente ? ['Cliente','Documento','Status','Ações'] : ['Cliente','Obra','Endereço','Último Laudo','Status','Ações'];
  const rows = cliente ? [['Construtora Exemplo','12.345.678/0001-90','Ativo','Editar'],['Cliente Demonstração','98.765.432/0001-10','Ativo','Editar']] : [['Construtora Exemplo','Edifício Central','Av. Principal, 100','10/07/2026','Ativa','Editar'],['Cliente Demonstração','Ponte Norte','Rodovia BR-000','08/07/2026','Ativa','Editar']];
  return <Box sx={{ bgcolor: fundo, minHeight: 270 }}><BarraSistema /><Box sx={{ p: 1.5 }}><Typography fontWeight={700} fontSize={15}>{titulo}</Typography>
    {!novo ? <><Stack direction="row" spacing={1} my={1}><Botao>+ Cadastrar {cliente ? 'Cliente' : 'Obra'}</Botao><Campo texto={etapa===2?'Exemplo':'Pesquisar'} /><Campo texto="Status: Ativos⌄" largura={125} /></Stack><Tabela cabecalhos={headers} linhas={rows} /></>:
    <Paper sx={{ p: 1.5, mt: 1 }}><Typography fontWeight={700}>{cliente?'Novo Cliente':'Nova Obra'}</Typography><Stack spacing={1} mt={1}>{!cliente&&<Campo texto="Selecione o cliente" />}<Campo texto={cliente?'Nome do Cliente':'Nome da Obra'} /><Campo texto={cliente?'CPF ou CNPJ':'Endereço da Obra'} /><Stack direction="row" justifyContent="flex-end" spacing={1}><Button size="small">Cancelar</Button><Botao>Salvar</Botao></Stack></Stack></Paper>}
  </Box></Box>;
}

function Laudos({ etapa }) {
  return <Box sx={{ bgcolor: fundo, minHeight: 270 }}><BarraSistema cliente /><Box sx={{ p: 1.5 }}><Paper sx={{ p: 1.4, bgcolor: "#0758a5", color: "white" }}><Typography fontWeight={700}>Laudos Técnicos da Obra</Typography><Typography fontSize={10}>Você está visualizando os laudos mais recentes das obras vinculadas.</Typography></Paper><Box mt={1}><Campo texto={etapa===1?'Obra Central':'Pesquisar obra'} /></Box><Paper sx={{ mt: 1, p: 1.2, borderLeft: "5px solid #1e88e5" }}><Stack direction="row" justifyContent="space-between"><Typography fontWeight={700} fontSize={12}>OBRA CENTRAL</Typography><span>{etapa>=2?'⌃':'⌄'}</span></Stack>{etapa>=2&&<Box sx={{ mt:1, pt:1, borderTop:'1px solid #ddd' }}><Typography fontWeight={700} fontSize={11}>Relatório de Dosagens</Typography><Stack direction="row" justifyContent="space-between" mt={.7}><Typography fontSize={10}>Dosagem nº 15 — Revisão 2</Typography><Botao>Baixar PDF</Botao></Stack>{etapa===3&&<Typography fontSize={9} color="text.secondary" mt={1}>Histórico: Revisão 1 • Revisão 0</Typography>}</Box>}</Paper></Box></Box>;
}

function Psicossocial({ etapa }) {
  if (etapa === 1) {
    return <Box sx={{ bgcolor: fundo, minHeight: 270 }}><BarraSistema /><Box sx={{ p: 1.5 }}><Typography fontWeight={700} fontSize={15}>Gestão psicossocial</Typography><Paper sx={{ mt: 1, p: 1.5 }}><Typography fontWeight={700}>Novo colaborador</Typography><Stack spacing={1} mt={1}><Campo texto="Empresa *" /><Stack direction="row" spacing={1}><Campo texto="Nome *" /><Campo texto="Identificação" /></Stack><Stack direction="row" spacing={1}><Campo texto="Setor" /><Campo texto="Função" /></Stack><Campo texto="Celular" /><Stack direction="row" justifyContent="flex-end" spacing={1}><Button size="small">Cancelar</Button><Botao>Salvar</Botao></Stack></Stack></Paper></Box></Box>;
  }

  if (etapa === 2) {
    return <Box sx={{ bgcolor: fundo, minHeight: 270 }}><BarraSistema /><Box sx={{ p: 1.5 }}><Typography fontWeight={700} fontSize={15}>Enviar links da pesquisa</Typography><Paper sx={{ mt: 1, p: 1.3 }}><Typography fontSize={10} color="text.secondary">Os links são individuais e ficam disponíveis para colaboradores pendentes.</Typography><Box mt={1}><Tabela cabecalhos={['Colaborador','Celular','Status','Link']} linhas={[['Ana Souza','(73) 99999-0001','Pendente','Copiar  •  WhatsApp'],['Carlos Lima','(73) 99999-0002','Pendente','Copiar  •  WhatsApp']]} /></Box><Stack direction="row" justifyContent="flex-end" spacing={1} mt={1}><Button size="small" variant="outlined">Copiar todos</Button><Botao verde>Enviar para todos</Botao></Stack></Paper></Box></Box>;
  }

  if (etapa === 3) {
    return <Box sx={{ bgcolor: fundo, minHeight: 270 }}><BarraSistema /><Box sx={{ p: 1.5 }}><Stack direction="row" justifyContent="space-between" alignItems="center"><Typography fontWeight={700} fontSize={15}>Acompanhamento psicossocial</Typography><Botao>Resultados</Botao></Stack><Stack direction="row" spacing={1} my={1}><Paper sx={{ flex: 1, p: 1.2, borderLeft: "4px solid #ed6c02" }}><Typography fontSize={10}>Pendentes</Typography><Typography fontSize={20} fontWeight={800}>12</Typography></Paper><Paper sx={{ flex: 1, p: 1.2, borderLeft: "4px solid #2e7d32" }}><Typography fontSize={10}>Respondidos</Typography><Typography fontSize={20} fontWeight={800}>28</Typography></Paper></Stack><Tabela cabecalhos={['Colaborador','Empresa','Setor / Função','Status','Ações']} linhas={[['Ana Souza','Empresa Exemplo','Administrativo / Analista','Respondido','Editar'],['Carlos Lima','Empresa Exemplo','Operacional / Técnico','Pendente','Editar']]} /></Box></Box>;
  }

  return <Box sx={{ bgcolor: fundo, minHeight: 270 }}><BarraSistema /><Box sx={{ p: 1.5 }}><Typography fontWeight={700} fontSize={15}>Gestão psicossocial</Typography><Stack direction="row" spacing={1} my={1}><Botao>Novo colaborador</Botao><Botao verde>Enviar para todos</Botao><Campo texto="Empresa: Todas⌄" largura={180} /></Stack><Tabela cabecalhos={['Colaborador','Empresa','Setor / Função','Celular','Status','Link','Ações']} linhas={[['Ana Souza','Empresa Exemplo','Administrativo / Analista','(73) 99999-0001','Respondido','—','Editar'],['Carlos Lima','Empresa Exemplo','Operacional / Técnico','(73) 99999-0002','Pendente','Copiar • WhatsApp','Editar']]} /></Box></Box>;
}

function Agenda({ etapa }) {
  const listaObras = etapa === 0;
  const listaMoldagens = etapa === 1;
  const formularioIdentificacao = etapa === 2;
  const formularioTecnico = etapa === 3;
  const dados = etapa === 4;
  const relatorio = etapa === 5;
  return <Box sx={{ bgcolor: fundo, minHeight: 270 }}><BarraSistema /><Box sx={{ p: 1.3 }}><Typography fontWeight={700} fontSize={15}>Agenda de Moldagem e Ruptura</Typography>
    {listaObras&&<><Stack direction="row" spacing={1} my={1}><Botao>+ Cadastrar Moldagem</Botao><Campo texto="Pesquisar Obra" /><Campo texto="Relatórios cadastrados⌄" largura={160} /></Stack>{['AERO 407','BARRAGEM DO COCO','HOSPITAL DA MULHER'].map((x,i)=><Paper key={x} sx={{ px:1,py:.8,mb:.5,display:'flex',alignItems:'center',fontSize:10 }}><b>{i+1}. &nbsp; {x}</b><Typography fontSize={9} color="text.secondary" ml="auto" mr={1}>Última alteração: 15/07/2026</Typography><Botao verde>Gerar relatório</Botao></Paper>)}</>}
    {listaMoldagens&&<><Stack direction="row" spacing={1} my={1}><Botao>← Voltar</Botao><Botao>+ Cadastrar Moldagem</Botao></Stack><Typography fontWeight={700} fontSize={12}>Obra: AERO 407</Typography><Box mt={1}><Campo texto="Pesquisar Moldagem (Data Moldagem, Data Ruptura ou Moldador)" /></Box>{['17/07/2026 — Moldador: N/I — Qtd Caminhões: 2','12/06/2026 — Moldador: Carlos — Qtd Caminhões: 1'].map(x=><Paper key={x} sx={{p:1,mt:.7,fontSize:10}}>● {x}<Box component="span" sx={{float:'right'}}>👁 &nbsp; 🖨 &nbsp; ✎ &nbsp; ↶</Box></Paper>)}</>}
    {formularioIdentificacao&&<Paper sx={{p:1.5,mt:1}}><Typography fontWeight={700}>Nova Moldagem — identificação</Typography><Stack spacing={1} mt={1}><Campo texto="Cliente: selecione o contratante"/><Campo texto="Obra: selecione a obra"/><Campo texto="Data Moldagem *"/><Campo texto="Responsável pela produção do concreto"/><Typography fontSize={10} fontWeight={700}>Responsável pela Moldagem</Typography><Typography fontSize={10}>◉ Empresa do laboratório &nbsp;&nbsp; ○ Construtora/Contratante</Typography><Stack direction="row" spacing={1}><Campo texto="Moldador"/><Campo texto="☐ N/I" largura={100}/></Stack><Typography fontSize={10}>☐ Ruptura externa (resultados enviados pelo cliente)</Typography></Stack></Paper>}
    {formularioTecnico&&<Paper sx={{p:1.5,mt:1}}><Typography fontWeight={700}>Nova Moldagem — configuração técnica</Typography><Stack spacing={1} mt={1}><Stack direction="row" spacing={1}><Campo texto="Nome do Traço"/><Campo texto="FCK de Projeto"/></Stack><Stack direction="row" spacing={1}><Campo texto="Slump de Projeto"/><Campo texto="Tolerância do Slump (mm)"/></Stack><Typography fontSize={10}>Tipo / Área do CP: ◉ 10×20 (7854 mm²) &nbsp; ○ Digitar Área</Typography><Stack direction="row" spacing={1}><Campo texto="Tipo de Capeamento"/><Campo texto="Tipo de Descarga: Bombeado⌄"/></Stack><Stack direction="row" spacing={1}><Campo texto="Qtd Caminhões"/><Campo texto="Quantidade de Idades"/><Campo texto="Dias da Idade 1"/></Stack><Box textAlign="right"><Botao verde>Salvar e abrir</Botao></Box></Stack></Paper>}
    {dados&&<><Stack direction="row" spacing={1} my={1}><Botao verde>Salvar Alterações</Botao><Botao>Cancelar alterações</Botao></Stack><Paper sx={{p:1,mt:1}}><Stack direction="row" spacing={1}><Campo texto="CLIENTE: Impermax Engenharia"/><Campo texto="DATA: 17/07/2026" largura={150}/></Stack><Stack direction="row" spacing={1} mt={1}><Campo texto="OBRA: Barragem do Coco"/><Campo texto="MOLDADOR: Silvio" largura={150}/></Stack><Stack direction="row" spacing={1} mt={1}><Campo texto="CONCRETEIRA: Produção na obra"/><Campo texto="FCK: 25 MPa" largura={130}/><Campo texto="SLUMP: 100 ± 10" largura={150}/></Stack></Paper><Box mt={1}><Tabela cabecalhos={['Nº','CÓD.','NOTA','QTD m³','SLUMP','28 dias','PEÇA','OBSERVAÇÕES','AÇÃO']} linhas={[[1,1,'010101','8,0',100,'18,7 / 21,8','PILAR','—','Salvar']]} /></Box></>}
    {relatorio&&<Paper sx={{p:1,mt:1,border:'1px solid #172033'}}><Typography textAlign="center" fontWeight={800} fontSize={11}>CONCRETO — ENSAIO DE COMPRESSÃO DE CORPOS DE PROVA CILÍNDRICOS — ABNT NBR 5739</Typography><Typography fontSize={9} mt={1}>DATA: 17/07/2026 &nbsp; | &nbsp; EMPRESA/CONTRATANTE: IMPERMAX ENGENHARIA</Typography><Typography fontSize={9}>OBRA: BARRAGEM DO COCO &nbsp; | &nbsp; RESPONSÁVEL PELA PRODUÇÃO: Produção na obra</Typography><Typography fontSize={9}>☒ Moldagem pelo laboratório &nbsp;&nbsp; ☐ Moldagem pela construtora &nbsp; | &nbsp; MOLDADOR: Silvio</Typography><Box mt={1}><Tabela cabecalhos={['Nº CP','Romaneio','Slump','Volume','Idade','Data','MPa','Peça','Observações']} linhas={[[1,'010101',100,'8,0','28 dias','22/10/1981','18,7 / 21,8','PILAR','—']]} /></Box><Stack direction="row" justifyContent="flex-end" spacing={1} mt={1}><Botao>Voltar</Botao><Botao>Imprimir</Botao></Stack></Paper>}
  </Box></Box>;
}

function CimentoTecnico({ etapa }) {
  const posicoesPrancha = [
    "0% 0%", "33.333% 0%", "66.666% 0%", "100% 0%",
    "0% 100%", "33.333% 100%", "66.666% 100%", "100% 100%",
  ];
  const etapas = [
    { titulo: "Condições controladas", icone: "🌡️", itens: ["Laboratório: 23 ± 2 °C", "Consistência: UR > 50%", "Pega: câmara úmida com UR ≥ 90%"] },
    { titulo: "Equipamentos", icone: "⚙️", itens: ["Balança com resolução de 0,1 g", "Misturador, cuba e espátulas", "Molde e aparelho de Vicat", "Cronômetro com precisão de 1 s"] },
    { titulo: "Preparação da pasta", icone: "🥣", itens: ["500,0 ± 0,5 g de cimento", "Água medida com precisão de 0,5 g", "30 s repouso • 30 s baixa • 60 s pausa • 60 s alta"] },
    { titulo: "Consistência normal", icone: "↕", itens: ["Encher e rasar sem comprimir", "Liberar a sonda 45 s após a mistura", "Ler após 30 s", "Resultado: 6 ± 1 mm da placa-base"] },
    { titulo: "Preparação para pega", icone: "◒", itens: ["Usar a pasta de consistência normal", "Armazenar em câmara úmida", "Tempo zero: contato água-cimento"] },
    { titulo: "Início de pega", icone: "↓", itens: ["Iniciar após pelo menos 30 min", "Leituras em pontos separados", "Intervalos aproximados de 10 min", "Critério: penetração a 6 ± 2 mm da placa"] },
    { titulo: "Fim de pega", icone: "⇅", itens: ["Usar agulha com acessório anular", "Inverter o molde", "Intervalos de até 30 min", "Critério: penetração de 0,5 mm sem marca anular"] },
    { titulo: "Resultados e registros", icone: "✓", itens: ["Consistência: água/cimento × 100", "Início de pega: aproximação de 5 min", "Fim de pega: aproximação de 15 min", "Registrar ambiente, massas, tempos e leituras"] },
  ];
  const atual = etapas[etapa] || etapas[0];
  return (
    <Box sx={{ bgcolor: "#eef4fb", border: "1px solid #aac2df", borderRadius: 1.5, overflow: "hidden" }}>
      <Box sx={{ bgcolor: "#07447f", color: "white", p: 1, textAlign: "center" }}>
        <Typography fontWeight={800} fontSize={13}>ENSAIO DE CONSISTÊNCIA E TEMPOS DE PEGA</Typography>
        <Typography fontSize={9}>ABNT NBR 16606:2018 e ABNT NBR 16607:2018</Typography>
      </Box>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "minmax(260px, 38%) 1fr" }, minHeight: 270 }}>
        <Box sx={{ bgcolor: "#dce9f7", p: 1.2, display: "grid", placeItems: "center" }}>
          <Box
            role="img"
            aria-label={`Ilustração técnica: ${atual.titulo}`}
            sx={{
              width: "100%",
              maxWidth: 330,
              aspectRatio: "1 / 1",
              borderRadius: 1,
              border: "1px solid #9db5cf",
              backgroundImage: "url('/Images/tutorial-ensaios/cimento-consistencia-pega-etapas.png')",
              backgroundRepeat: "no-repeat",
              backgroundSize: "400% 200%",
              backgroundPosition: posicoesPrancha[etapa] || posicoesPrancha[0],
              bgcolor: "white",
            }}
          />
        </Box>
        <Box sx={{ p: 2 }}>
          <Typography color="#064584" fontWeight={800} mb={1}>{etapa + 1}. {atual.titulo}</Typography>
          <Stack spacing={0.8}>
            {atual.itens.map((item) => <Box key={item} sx={{ display: "flex", gap: 1, fontSize: 11, color: "#26384a" }}><b style={{ color: "#0877cf" }}>●</b><span>{item}</span></Box>)}
          </Stack>
          <Box sx={{ mt: 1.5, p: 1, bgcolor: "white", borderLeft: "4px solid #f6a800", fontSize: 9 }}>
            Procedimento resumido para treinamento. Confirmar equipamento calibrado e procedimento interno aprovado antes da execução.
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

function EnsaioSistema({ etapa }) {
  if (etapa === 1) {
    return <Box sx={{ bgcolor: fundo, p: 1.5 }}><BarraSistema /><Paper sx={{ mt: 1.2, p: 1.5 }}><Typography fontWeight={700}>Novo Ensaio</Typography><Stack spacing={1} mt={1}><Stack direction="row" spacing={1}><Campo texto="Cliente" /><Campo texto="Obra / Empreendimento" /></Stack><Stack direction="row" spacing={1}><Campo texto="Data do ensaio" /><Campo texto="Responsável" /></Stack><Campo texto="Material / Amostra" /><Box textAlign="right"><Botao>Salvar e abrir</Botao></Box></Stack></Paper></Box>;
  }
  if (etapa === 2) {
    return <Box sx={{ bgcolor: fundo, p: 1.5 }}><BarraSistema /><Typography fontWeight={700} mt={1}>Lançamento do ensaio</Typography><Paper sx={{ mt: 1, p: 1.2 }}><Stack direction="row" spacing={1}><Campo texto="Leitura 1" /><Campo texto="Leitura 2" /><Campo texto="Resultado calculado" /></Stack><Box mt={1}><Tabela cabecalhos={['Etapa','Horário','Leitura','Unidade','Situação']} linhas={[[1,'08:00','25,4','mm','Conforme'],[2,'08:10','18,2','mm','Conforme']]} /></Box><Box textAlign="right" mt={1}><Botao>Salvar alterações</Botao></Box></Paper></Box>;
  }
  if (etapa === 3) {
    return <Box sx={{ bgcolor: fundo, p: 1.5 }}><BarraSistema /><Typography fontWeight={700} mt={1}>Relatório do ensaio</Typography><Paper sx={{ mt: 1, p: 2, textAlign: 'center' }}><Typography fontSize={11}>SISTEMA DE GESTÃO DA QUALIDADE</Typography><Typography fontWeight={700} my={2}>RESULTADOS DO ENSAIO</Typography><Stack direction="row" justifyContent="center" spacing={1}><Botao>Visualizar</Botao><Botao>Imprimir</Botao><Button size="small">Histórico</Button></Stack></Paper></Box>;
  }
  return <Box sx={{ bgcolor: fundo, minHeight: 260 }}><BarraSistema /><Box sx={{ p: 1.5 }}><Typography fontWeight={700}>Ensaios cadastrados</Typography><Stack direction="row" spacing={1} my={1}><Botao>+ Novo Ensaio</Botao><Campo texto="Pesquisar código, cliente, obra ou material" /><Campo texto="Status: Todos⌄" largura={130} /></Stack><Tabela cabecalhos={['Código','Data','Cliente','Obra','Material','Status','Ações']} linhas={[[125,'10/07/2026','Cliente Exemplo','Obra Central','Amostra A','Concluído','◉  🖨  ✎'],[124,'09/07/2026','Empresa Demo','Ponte Norte','Amostra B','Em andamento','◉  ✎']]} /></Box></Box>;
}

function ConcretoTecnico({ etapa }) {
  const titulos = [
    "Amostragem do concreto fresco",
    "Abatimento do tronco de cone",
    "Moldagem dos corpos de prova",
    "Cura dos corpos de prova",
    "Compressão axial",
    "Extração de testemunhos",
    "Módulo dinâmico por vibração",
    "Preparação de concreto em laboratório",
  ];
  const posicoes = ["0% 0%", "33.333% 0%", "66.666% 0%", "100% 0%", "0% 100%", "33.333% 100%", "66.666% 100%", "100% 100%"];
  return (
    <Box sx={{ bgcolor: "#eef4fb", border: "1px solid #aac2df", borderRadius: 1.5, overflow: "hidden" }}>
      <Box sx={{ bgcolor: "#07447f", color: "white", p: 1, textAlign: "center" }}>
        <Typography fontWeight={800} fontSize={13}>{titulos[etapa] || "Ensaio de concreto"}</Typography>
      </Box>
      <Box sx={{ p: 1.2, bgcolor: "#dce9f7", display: "grid", placeItems: "center" }}>
        <Box
          role="img"
          aria-label={`Ilustração técnica: ${titulos[etapa] || "ensaio de concreto"}`}
          sx={{
            width: "100%",
            maxWidth: 430,
            aspectRatio: "3 / 4",
            border: "1px solid #9db5cf",
            borderRadius: 1,
            backgroundImage: "url('/Images/tutorial-ensaios/concreto-etapas.png')",
            backgroundRepeat: "no-repeat",
            backgroundSize: "400% 200%",
            backgroundPosition: posicoes[etapa] || posicoes[0],
            bgcolor: "white",
          }}
        />
      </Box>
    </Box>
  );
}

function AgregadosTecnico({ etapa }) {
  const titulos = [
    "Composição granulométrica",
    "Densidade e absorção de água",
    "Massa unitária e índice de vazios",
    "Material fino por lavagem",
    "Abrasão Los Angeles",
    "Índice de forma por paquímetro",
    "Impurezas orgânicas e equivalente de areia",
    "Reatividade álcali-agregado",
  ];
  const posicoes = ["0% 0%", "33.333% 0%", "66.666% 0%", "100% 0%", "0% 100%", "33.333% 100%", "66.666% 100%", "100% 100%"];
  return (
    <Box sx={{ bgcolor: "#eef4fb", border: "1px solid #aac2df", borderRadius: 1.5, overflow: "hidden" }}>
      <Box sx={{ bgcolor: "#07447f", color: "white", p: 1, textAlign: "center" }}>
        <Typography fontWeight={800} fontSize={13}>{titulos[etapa] || "Ensaio de agregados"}</Typography>
      </Box>
      <Box sx={{ p: 1.2, bgcolor: "#dce9f7", display: "grid", placeItems: "center" }}>
        <Box
          role="img"
          aria-label={`Ilustração técnica: ${titulos[etapa] || "ensaio de agregados"}`}
          sx={{
            width: "100%",
            maxWidth: 430,
            aspectRatio: "3 / 4",
            border: "1px solid #9db5cf",
            borderRadius: 1,
            backgroundImage: "url('/Images/tutorial-ensaios/agregados-etapas.png')",
            backgroundRepeat: "no-repeat",
            backgroundSize: "400% 200%",
            backgroundPosition: posicoes[etapa] || posicoes[0],
            bgcolor: "white",
          }}
        />
      </Box>
    </Box>
  );
}

function SolosTecnico({ etapa }) {
  const titulos = [
    "Preparação da amostra de solo",
    "Ensaio de compactação",
    "Condicionamento e expansão CBR",
    "Penetração CBR",
    "Análise granulométrica de solos",
    "Limite de liquidez",
    "Limite de plasticidade",
    "Densidade in situ pelo frasco de areia",
  ];
  const posicoes = ["0% 0%", "33.333% 0%", "66.666% 0%", "100% 0%", "0% 100%", "33.333% 100%", "66.666% 100%", "100% 100%"];
  return (
    <Box sx={{ bgcolor: "#eef4fb", border: "1px solid #aac2df", borderRadius: 1.5, overflow: "hidden" }}>
      <Box sx={{ bgcolor: "#07447f", color: "white", p: 1, textAlign: "center" }}>
        <Typography fontWeight={800} fontSize={13}>{titulos[etapa] || "Ensaio de solos"}</Typography>
      </Box>
      <Box sx={{ p: 1.2, bgcolor: "#dce9f7", display: "grid", placeItems: "center" }}>
        <Box
          role="img"
          aria-label={`Ilustração técnica: ${titulos[etapa] || "ensaio de solos"}`}
          sx={{
            width: "100%",
            maxWidth: 430,
            aspectRatio: "3 / 4",
            border: "1px solid #9db5cf",
            borderRadius: 1,
            backgroundImage: "url('/Images/tutorial-ensaios/solos-etapas.png')",
            backgroundRepeat: "no-repeat",
            backgroundSize: "400% 200%",
            backgroundPosition: posicoes[etapa] || posicoes[0],
            bgcolor: "white",
          }}
        />
      </Box>
    </Box>
  );
}

function ComponentesTecnico({ etapa }) {
  const titulos = [
    "Peças de concreto para pavimentação",
    "Blocos e tijolos cerâmicos",
    "Resistência de aderência à tração",
    "Adesividade de agregado ao ligante",
    "Verificação de prensa de concreto",
    "Verificação de prensa de solos/CBR",
    "Controle do tanque de cura",
    "Verificação e rastreabilidade de equipamentos",
  ];
  const posicoes = ["0% 0%", "33.333% 0%", "66.666% 0%", "100% 0%", "0% 100%", "33.333% 100%", "66.666% 100%", "100% 100%"];
  return (
    <Box sx={{ bgcolor: "#eef4fb", border: "1px solid #aac2df", borderRadius: 1.5, overflow: "hidden" }}>
      <Box sx={{ bgcolor: "#07447f", color: "white", p: 1, textAlign: "center" }}>
        <Typography fontWeight={800} fontSize={13}>{titulos[etapa] || "Ensaio de componente"}</Typography>
      </Box>
      <Box sx={{ p: 1.2, bgcolor: "#dce9f7", display: "grid", placeItems: "center" }}>
        <Box
          role="img"
          aria-label={`Ilustração técnica: ${titulos[etapa] || "ensaio de componente"}`}
          sx={{
            width: "100%",
            maxWidth: 430,
            aspectRatio: "3 / 4",
            border: "1px solid #9db5cf",
            borderRadius: 1,
            backgroundImage: "url('/Images/tutorial-ensaios/componentes-equipamentos-etapas.png')",
            backgroundRepeat: "no-repeat",
            backgroundSize: "400% 200%",
            backgroundPosition: posicoes[etapa] || posicoes[0],
            bgcolor: "white",
          }}
        />
      </Box>
    </Box>
  );
}

const PRANCHAS_DEDICADAS = {
  "raa-execucao": {
    titulo: "Reatividade álcali-agregado",
    arquivos: [
      "raa-preparacao-v2.png",
      "raa-moldagem-v2.png",
      "raa-cura-v2.png",
      "raa-leituras-v2.png",
      "raa-avaliacao-v2.png",
    ],
  },
  "paver-execucao": ["paver-etapas.png", "Ensaio em peças de concreto para pavimentação"],
  "bloco-ceramico-execucao": ["bloco-ceramico-etapas.png", "Ensaio em blocos cerâmicos"],
  "aderencia-tracao-execucao": ["aderencia-tracao-etapas.png", "Aderência à tração de revestimentos"],
  "adesividade-ligante-execucao": ["adesividade-ligante-etapas.png", "Adesividade ao ligante asfáltico"],
  "calibracao-prensa-execucao": ["calibracao-prensa-etapas.png", "Verificação da prensa de concreto"],
  "calibracao-prensa-solos-execucao": ["calibracao-prensa-solos-etapas.png", "Verificação da prensa de solos/CBR"],
  "tanque-cura-execucao": ["tanque-cura-etapas.png", "Controle do tanque de cura"],
  "extracoes-execucao": ["extracoes-testemunhos-etapas.png", "Extração e ensaio de testemunhos", 4],
  "modulo-dinamico-execucao": ["modulo-dinamico-etapas.png", "Módulo de elasticidade dinâmico", 4],
  "dosagem-execucao": ["dosagem-concreto-etapas.png", "Dosagem de concreto em laboratório", 5],
  "mescla-asfaltica-execucao": ["mescla-asfaltica-etapas.png", "Granulometria e mescla asfáltica", 4],
};

function PranchaDedicada({ familia, etapa }) {
  const configuracao = PRANCHAS_DEDICADAS[familia] || [];
  const imagensIndividuais = Array.isArray(configuracao.arquivos);
  const [arquivoPrancha, tituloPrancha, totalPrancha = 5] = imagensIndividuais ? [] : configuracao;
  const titulo = imagensIndividuais ? configuracao.titulo : tituloPrancha;
  const total = imagensIndividuais ? configuracao.arquivos.length : totalPrancha;
  const proporcaoPrancha = total === 4 ? "1 / 2" : "2 / 5";
  const indice = Math.max(0, Math.min(total - 1, etapa));
  const arquivo = imagensIndividuais ? configuracao.arquivos[indice] : arquivoPrancha;
  const posicao = `${(indice / Math.max(1, total - 1)) * 100}% 0%`;
  return (
    <Box sx={{ bgcolor: "#eef4fb", border: "1px solid #aac2df", borderRadius: 1.5, overflow: "hidden" }}>
      <Box sx={{ bgcolor: "#07447f", color: "white", p: 1, textAlign: "center" }}>
        <Typography fontWeight={800} fontSize={13}>{titulo}</Typography>
      </Box>
      <Box sx={{ p: 1.2, bgcolor: "#dce9f7", display: "grid", placeItems: "center" }}>
        {imagensIndividuais ? (
          <Box
            component="img"
            src={`/Images/tutorial-ensaios/${arquivo}`}
            alt={`Ilustração técnica da etapa ${indice + 1}: ${titulo}`}
            sx={{
              display: "block",
              width: "100%",
              maxWidth: 720,
              maxHeight: 430,
              objectFit: "contain",
              border: "1px solid #9db5cf",
              borderRadius: 1,
              bgcolor: "white",
            }}
          />
        ) : (
          <Box
            role="img"
            aria-label={`Ilustração técnica da etapa ${indice + 1}: ${titulo}`}
            sx={{
              width: "100%",
              maxWidth: total === 4 ? 250 : 200,
              aspectRatio: proporcaoPrancha,
              border: "1px solid #9db5cf",
              borderRadius: 1,
              backgroundImage: `url('/Images/tutorial-ensaios/${arquivo}')`,
              backgroundRepeat: "no-repeat",
              backgroundSize: `${total * 100}% 100%`,
              backgroundPosition: posicao,
              bgcolor: "white",
            }}
          />
        )}
      </Box>
    </Box>
  );
}

export default function TutorialPreview({ tipo = "" }) {
  const [tela, indice = "0"] = tipo.split(":");
  const etapa = Number(indice);
  if (tela === "dashboard") return <Dashboard etapa={etapa} />;
  if (tela === "materiais") return <Materiais etapa={etapa} />;
  if (tela === "clientes" || tela === "obras") return <CadastroSimples tipo={tela} etapa={etapa} />;
  if (tela === "laudos") return <Laudos etapa={etapa} />;
  if (tela === "psicossocial") return <Psicossocial etapa={etapa} />;
  if (tela === "agenda") return <Agenda etapa={etapa} />;
  if (tela === "cimento-execucao") return <CimentoTecnico etapa={etapa} />;
  if (tela === "cimento-sistema") return <Materiais etapa={etapa === 2 ? 2 : 0} />;
  if (tela === "ensaio-sistema") return <EnsaioSistema etapa={etapa} />;
  if (tela === "concreto-execucao") return <ConcretoTecnico etapa={etapa} />;
  if (tela === "agregados-execucao") return <AgregadosTecnico etapa={etapa} />;
  if (tela === "solos-execucao") return <SolosTecnico etapa={etapa} />;
  if (tela === "componentes-execucao") return <ComponentesTecnico etapa={etapa} />;
  if (PRANCHAS_DEDICADAS[tela]) return <PranchaDedicada familia={tela} etapa={etapa} />;
  return null;
}
